import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/design-system.css';
import './index.css';
import './components/Navbar.css';
import './vehicle-details.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);